import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchBusinessInfoApi, updateBusinessInfoApi } from "../../api/businessInfoApi";
import * as Endpoints from "../../entities/Endpoints"

// Async thunk to fetch business information
export const fetchBusinessInfo = createAsyncThunk(
  Endpoints.GET_BUSINESS_INFO_BY_COACH_ID,
  async ({coachId}, { rejectWithValue }) => {
    try {
      const response = await fetchBusinessInfoApi(coachId);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.data.message|| "An error occurred");
    }
  }
);

// Async thunk to update business information
export const updateBusinessInfo = createAsyncThunk(
  Endpoints.UPDATE_BUSINESS_INFO,
  async (businessData, { rejectWithValue }) => {
    try {
      return await updateBusinessInfoApi(businessData);
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Business slice
const businessSlice = createSlice({
  name: "business",
  initialState: {
    businessInfo: null,
    isLoading: false,
    error: null,
    updateSuccess: false,
    updateError: false
  },
  reducers: {
    resetBusinessState: (state) => {
      state.updateSuccess = false;
      state.updateError = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessInfo.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchBusinessInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.businessInfo = action.payload;
      })
      .addCase(fetchBusinessInfo.rejected, (state, action) => {
        state.isLoading = true;
        state.error = action.payload;
      })
      .addCase(updateBusinessInfo.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.updateSuccess = false;
        state.updateError = false;
      })
      .addCase(updateBusinessInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.businessInfo = action.payload;
        state.updateSuccess = true;
        state.updateError = false;
      })
      .addCase(updateBusinessInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        state.updateSuccess = false;
        state.updateError = true;
      });
  },
});

export const { resetBusinessState } = businessSlice.actions;

export const businessReducer = businessSlice.reducer;
